import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconMinusPrice = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
      <path
        d="M4.00065 8.33333C3.81176 8.33333 3.65354 8.26933 3.52599 8.14133C3.39843 8.01333 3.33443 7.85511 3.33399 7.66667C3.33354 7.47822 3.39754 7.32 3.52599 7.192C3.65443 7.064 3.81265 7 4.00065 7H12.0007C12.1895 7 12.348 7.064 12.476 7.192C12.604 7.32 12.6678 7.47822 12.6673 7.66667C12.6669 7.85511 12.6029 8.01356 12.4753 8.142C12.3478 8.27044 12.1895 8.33422 12.0007 8.33333H4.00065Z"
        fill={theme.colors.text.primary}
      />
    </IconBase>
  )
}
